import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  UpdateSettingInput,
  UpdateFlexibleBenefitsSettingsVariables,
  UpdateFlexibleBenefitsSettingsResponse,
} from '../types';

const updateFlexibleBenefitsSettingsMutation = gql`
  mutation UpdateFlexibleBenefitsSettings($input: UpdateSettingInput!) {
    payrollUpdateSetting(input: $input) {
      success
      message
      code
      data
    }
  }
`;

export const updateFlexibleBenefitsSettings = (
  input: UpdateSettingInput,
): Promise<UpdateFlexibleBenefitsSettingsResponse> => {
  return graphQLApi<
    UpdateFlexibleBenefitsSettingsResponse,
    UpdateFlexibleBenefitsSettingsVariables
  >({
    query: updateFlexibleBenefitsSettingsMutation,
    queryVariables: {
      input,
    },
  });
};
